<button class="hvac-browse-tile hvac-browse-subcategories-tile" (click)="browseTo(category)">
    <p class="hvac-browse-tile-title">{{ category.name }}</p>
</button>
